import axios from "axios"
import * as localStorage from "./localStorage.js"

export default function server(headerAdded) {

    const data = localStorage.getData()

    // let url = 'https://boilerplate-adonisv6n-production.up.railway.app/' // 'https://api.fizaqui.com/'
    let url = 'https://api.fizaqui.com:8443/'

    if (window.location.origin.includes('localhost')) {
        url = 'http://localhost:3333/'
    } else if (window.location.origin.includes('192.168.0.12')) {
        url = 'http://192.168.0.12:3333/'
    }

    const instance = axios.create({
        baseURL: url,
        timeout: 5000,
        headers: {
            'Content-Type': "application/json; charset=utf-8",
            'Authorization': "Bearer " + data.token,
            ...headerAdded
        }
    })
    instance.interceptors.response.use((response) => {
        return response
    }, (error) => {

        console.log('Erro (server): ', error)

        if (error.response && error.response.data && error.response.data.errors) {
            const reason = error.response.data.errors[0].message

            if (reason.includes('E_INVALID_API_TOKEN')) {
                localStorage.deleteToken()
                alert("(Server) Token inválido!")
                window.location.href = '/login'
            }
        }

        return Promise.reject(error)

    })

    return instance

}